import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/AuthContext";

import Landing from "@/pages/Landing";
import Formations from "@/pages/Formations";
import Login from "@/pages/Login";
import Inscription from "@/pages/Inscription";
import Devis from "@/pages/Devis";
import SimulateurSalaire from "@/pages/SimulateurSalaire";
import PayCheckout from "@/pages/PayCheckout";

import AdminLayout from "@/layouts/AdminLayout";
import ChefLayout from "@/layouts/ChefLayout";
import SalarieLayout from "@/layouts/SalarieLayout";
import SyndicatLayout from "@/layouts/SyndicatLayout";
import AssociationLayout from "@/layouts/AssociationLayout";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminDashboardWidgets from "@/pages/admin/AdminDashboardWidgets";
import AdminEntreprises from "@/pages/admin/AdminEntreprises";
import AdminEntrepriseDetail from "@/pages/admin/AdminEntrepriseDetail";
import AdminPaiement from "@/pages/admin/AdminPaiement";
import AdminPayPal from "@/pages/admin/AdminPayPal";
import AdminTwilio from "@/pages/admin/AdminTwilio";
import AdminTalk from "@/pages/admin/AdminTalk";
import AdminStudio from "@/pages/admin/AdminStudio";
import AdminStudioModule from "@/pages/admin/AdminStudioModule";
import AdminMetiers from "@/pages/admin/AdminMetiers";
import MarketplacePage from "@/pages/marketplace/MarketplacePage";
import BilletteriePage from "@/pages/billetterie/BilletteriePage";
import AdminMarketplace from "@/pages/admin/AdminMarketplace";
import AdminBilletterie from "@/pages/admin/AdminBilletterie";
import BpBilletterie from "@/pages/bp/BpBilletterie";
import PublicTicket from "@/pages/PublicTicket";
import ChefModulePage from "@/pages/chef/ChefModulePage";
import SalarieModulePage from "@/pages/salarie/SalarieModulePage";
import AdminSendGrid from "@/pages/admin/AdminSendGrid";
import AdminPromotions from "@/pages/admin/AdminPromotions";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminI18n from "@/pages/admin/AdminI18n";
import AdminFormations from "@/pages/admin/AdminFormations";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminInscriptions from "@/pages/admin/AdminInscriptions";
import AdminHealth from "@/pages/admin/AdminHealth";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminBaremes from "@/pages/admin/AdminBaremes";
import AdminAudit from "@/pages/admin/AdminAudit";
import Admin2FA from "@/pages/admin/Admin2FA";
import AdminSecureConnect from "@/pages/admin/AdminSecureConnect";
import AdminAnnouncements from "@/pages/admin/AdminAnnouncements";
import AdminSupport from "@/pages/admin/AdminSupport";
import AdminSyndicats from "@/pages/admin/AdminSyndicats";
import AdminAssociations from "@/pages/admin/AdminAssociations";
import AdminCancellations from "@/pages/admin/AdminCancellations";
import AdminEmails from "@/pages/admin/AdminEmails";
import AdminAutomations from "@/pages/admin/AdminAutomations";
import AdminIncidents from "@/pages/admin/AdminIncidents";
import AdminIntegrations from "@/pages/admin/AdminIntegrations";
import PaymentSuccess from "@/pages/PaymentSuccess";
import StatusPage from "@/pages/StatusPage";
import LegalPage from "@/pages/LegalPage";
import Carrieres from "@/pages/Carrieres";
import CarriereOffre from "@/pages/CarriereOffre";
import CarriereSpontanee from "@/pages/CarriereSpontanee";
import AdminRecrutement from "@/pages/admin/AdminRecrutement";
import AdminBusinessPartners from "@/pages/admin/AdminBusinessPartners";
import BpLayout from "@/layouts/BpLayout";
import BpDashboard from "@/pages/bp/BpDashboard";
import BpLeads from "@/pages/bp/BpLeads";
import BpCatalog from "@/pages/bp/BpCatalog";
import BpReglement from "@/pages/bp/BpReglement";
import BpProfil from "@/pages/bp/BpProfil";
import BpGains from "@/pages/bp/BpGains";
import BpContrat from "@/pages/bp/BpContrat";
import BpMinisite from "@/pages/bp/BpMinisite";
import PartenairePublic from "@/pages/PartenairePublic";
import ChefLegal from "@/pages/chef/ChefLegal";
import SalarieLegal from "@/pages/salarie/SalarieLegal";
import AdminLegal from "@/pages/admin/AdminLegal";

import ChefDashboard from "@/pages/chef/ChefDashboard";
import ChefDashboardSettings from "@/pages/chef/ChefDashboardSettings";
import ChefSalaries from "@/pages/chef/ChefSalaries";
import ChefPlanning from "@/pages/chef/ChefPlanning";
import ChefConges from "@/pages/chef/ChefConges";
import ChefPaie from "@/pages/chef/ChefPaie";
import ChefDocuments from "@/pages/chef/ChefDocuments";
import ChefNotifications from "@/pages/chef/ChefNotifications";
import ChefProfilEntreprise from "@/pages/chef/ChefProfilEntreprise";
import ChefHelper from "@/pages/chef/ChefHelper";
import ChefBanques from "@/pages/chef/ChefBanques";
import ChefSimulateur from "@/pages/chef/ChefSimulateur";
import ChefFinance from "@/pages/chef/ChefFinance";
import ChefCSE from "@/pages/chef/ChefCSE";
import ChefHACCP from "@/pages/chef/secteur/ChefHACCP";
import ChefRondes from "@/pages/chef/secteur/ChefRondes";
import ChefChantiers from "@/pages/chef/secteur/ChefChantiers";
import ChefRDV from "@/pages/chef/secteur/ChefRDV";
import ChefVehicules from "@/pages/chef/secteur/ChefVehicules";
import ChefReservations from "@/pages/chef/secteur/ChefReservations";
import ChefHebergement from "@/pages/chef/ChefReservations";
import ChefEncaissement from "@/pages/chef/ChefEncaissement";
import PublicReservation from "@/pages/PublicReservation";
import PublicBooking from "@/pages/PublicBooking";
import PublicClientBookings from "@/pages/PublicClientBookings";
import PublicModuleRequest from "@/pages/PublicModuleRequest";
import ChefBiens from "@/pages/chef/secteur/ChefBiens";
import ChefPensionnaires from "@/pages/chef/secteur/ChefPensionnaires";
import ChefAbonnes from "@/pages/chef/secteur/ChefAbonnes";
import ChefProduction from "@/pages/chef/secteur/ChefProduction";

import EducationEleves from "@/pages/chef/education/EducationEleves";
import EducationClasses from "@/pages/chef/education/EducationClasses";
import EducationNotes from "@/pages/chef/education/EducationNotes";
import EducationBulletins from "@/pages/chef/education/EducationBulletins";
import EducationPresences from "@/pages/chef/education/EducationPresences";
import EducationPresencesMonthly from "@/pages/chef/education/EducationPresencesMonthly";
import EducationParents from "@/pages/chef/education/EducationParents";

import ChefMiniSite from "@/pages/chef/ChefMiniSite";
import ChefTemplatesRH from "@/pages/chef/ChefTemplatesRH";
import ChefSites from "@/pages/chef/ChefSites";
import ChefFacturation from "@/pages/chef/ChefFacturation";
import ChefSecurityCenter from "@/pages/chef/ChefSecurityCenter";
import ChefClients from "@/pages/chef/ChefClients";
import ChefAvis from "@/pages/chef/ChefAvis";
import ChefDevisFactures from "@/pages/chef/ChefDevisFactures";
import ChefRapprochement from "@/pages/chef/ChefRapprochement";
import ChefCRM from "@/pages/chef/ChefCRM";
import ChefContrats from "@/pages/chef/ChefContrats";
import SalarieContrat from "@/pages/salarie/SalarieContrat";
import ChefPointage from "@/pages/chef/ChefPointage";
import ChefTalk from "@/pages/chef/ChefTalk";
import ChefTitresRestaurant from "@/pages/chef/ChefTitresRestaurant";
import AdminBilling from "@/pages/admin/AdminBilling";
import AdminStripeConnect from "@/pages/admin/AdminStripeConnect";
import AdminStripe from "@/pages/admin/AdminStripe";
import SalarieTitresRestaurant from "@/pages/salarie/SalarieTitresRestaurant";
import ChefVisitesMedicales from "@/pages/chef/ChefVisitesMedicales";
import SalariePointage from "@/pages/salarie/SalariePointage";
import SalarieTalk from "@/pages/salarie/SalarieTalk";
import SalarieVisitesMedicales from "@/pages/salarie/SalarieVisitesMedicales";
import PublicReview from "@/pages/PublicReview";
import ChefPaieFiscal from "@/pages/chef/ChefPaieFiscal";
import ChefQualiParcInterventions from "@/pages/chef/qualiparc/ChefQualiParcInterventions";
import ChefQualiParcAudits from "@/pages/chef/qualiparc/ChefQualiParcAudits";
import ChefQualiParcTickets from "@/pages/chef/qualiparc/ChefQualiParcTickets";
import PublicMiniSite from "@/pages/PublicMiniSite";
import PublicMiniSiteSuccess from "@/pages/PublicMiniSiteSuccess";
import ParentThread from "@/pages/ParentThread";
import PublicWebSite from "@/pages/web/PublicWebSite";
import PublicWebOrder from "@/pages/web/PublicWebOrder";
import SiteBuilderPage from "@/pages/web/SiteBuilderPage";
import AdminWebSites from "@/pages/admin/AdminWebSites";
import AdminWebSiteEdit from "@/pages/admin/AdminWebSiteEdit";
import { HostSiteGate } from "@/components/web/public/HostSiteGate";

import SyndicatDashboard from "@/pages/syndicat/SyndicatDashboard";
import SyndicatAdherents from "@/pages/syndicat/SyndicatAdherents";
import SyndicatPlaintes from "@/pages/syndicat/SyndicatPlaintes";
import SyndicatActualites from "@/pages/syndicat/SyndicatActualites";

import AssociationDashboard from "@/pages/association/AssociationDashboard";
import AssociationAdherents from "@/pages/association/AssociationAdherents";
import AssociationPlaintes from "@/pages/association/AssociationPlaintes";
import AssociationActualites from "@/pages/association/AssociationActualites";

import SalarieSyndicat from "@/pages/salarie/SalarieSyndicat";

import SalarieDashboard from "@/pages/salarie/SalarieDashboard";
import SalarieDashboardSettings from "@/pages/salarie/SalarieDashboardSettings";
import SalariePlanning from "@/pages/salarie/SalariePlanning";
import SalarieConges from "@/pages/salarie/SalarieConges";
import SalariePaie from "@/pages/salarie/SalariePaie";
import SalarieRemuneration from "@/pages/salarie/SalarieRemuneration";
import SalarieDocuments from "@/pages/salarie/SalarieDocuments";
import SalarieMessages from "@/pages/salarie/SalarieMessages";
import SalarieHelper from "@/pages/salarie/SalarieHelper";
import SalarieCardID from "@/pages/salarie/SalarieCardID";
import SalarieInterventions from "@/pages/salarie/SalarieInterventions";
import SalarieTickets from "@/pages/salarie/SalarieTickets";
import SalarieNotifications from "@/pages/salarie/SalarieNotifications";
import SalarieEtablissement from "@/pages/salarie/SalarieEtablissement";

function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Chargement…</div>;
  if (!user) return <Navigate to="/login/chef" replace />;
  if (role && user.role !== role && !(role === "admin" && user.role === "staff")) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <HostSiteGate>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/s/:slug" element={<PublicWebSite />} />
          <Route path="/s/:slug/commande/:ref" element={<PublicWebOrder />} />
          <Route path="/s/:slug/:page" element={<PublicWebSite />} />
          <Route path="/status" element={<StatusPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/legal/:key" element={<LegalPage />} />
          <Route path="/carrieres" element={<Carrieres />} />
          <Route path="/carrieres/spontanee" element={<CarriereSpontanee />} />
          <Route path="/carrieres/:id" element={<CarriereOffre />} />
          <Route path="/partenaires/:code" element={<PartenairePublic />} />
          <Route path="/formations" element={<Formations />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/devis" element={<Devis />} />
          <Route path="/simulateur-salaire" element={<SimulateurSalaire />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/pay/checkout/:inscriptionId" element={<PayCheckout />} />
          <Route path="/login" element={<Navigate to="/login/chef" replace />} />
          <Route path="/sites/:code" element={<PublicMiniSite />} />
          <Route path="/sites/:code/success" element={<PublicMiniSiteSuccess />} />
          <Route path="/sites/:code/reservation" element={<PublicReservation />} />
          <Route path="/sites/:code/reservation/:token" element={<PublicBooking />} />
          <Route path="/sites/:code/mes-reservations/:token" element={<PublicClientBookings />} />
          <Route path="/sites/:code/demande/:key/:ekey" element={<PublicModuleRequest />} />
          <Route path="/sites/:code/avis/:token" element={<PublicReview />} />
          <Route path="/parent/:token" element={<ParentThread />} />
          <Route path="/billet/:token" element={<PublicTicket />} />
          <Route path="/login/:roleHint" element={<Login />} />

          {/* ADMIN */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="widgets" element={<AdminDashboardWidgets />} />
            <Route path="entreprises" element={<AdminEntreprises />} />
            <Route path="entreprises/:id" element={<AdminEntrepriseDetail />} />
            <Route path="inscriptions" element={<AdminInscriptions />} />
            <Route path="syndicats" element={<AdminSyndicats />} />
            <Route path="associations" element={<AdminAssociations />} />
            <Route path="paiement" element={<AdminPaiement />} />
            <Route path="paypal" element={<AdminPayPal />} />
            <Route path="twilio" element={<AdminTwilio />} />
            <Route path="talk" element={<AdminTalk />} />
            <Route path="studio" element={<AdminStudio />} />
            <Route path="studio/:mid" element={<AdminStudioModule />} />
            <Route path="marketplace" element={<AdminMarketplace />} />
            <Route path="billetterie" element={<AdminBilletterie />} />
            <Route path="metiers" element={<AdminMetiers />} />
            <Route path="recrutement" element={<AdminRecrutement />} />
            <Route path="business-partners" element={<AdminBusinessPartners />} />
            <Route path="sendgrid" element={<AdminSendGrid />} />
            <Route path="promotions" element={<AdminPromotions />} />
            <Route path="notifications" element={<AdminNotifications />} />
            <Route path="i18n" element={<AdminI18n />} />
            <Route path="web" element={<AdminWebSites />} />
            <Route path="web/:sid" element={<AdminWebSiteEdit />} />
            <Route path="formations" element={<AdminFormations />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="announcements" element={<AdminAnnouncements />} />
            <Route path="support" element={<AdminSupport />} />
            <Route path="health" element={<AdminHealth />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="baremes" element={<AdminBaremes />} />
            <Route path="sms" element={<Navigate to="/admin/twilio" replace />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="2fa" element={<Admin2FA />} />
            <Route path="secure-connect" element={<AdminSecureConnect />} />
            <Route path="cancellations" element={<AdminCancellations />} />
            <Route path="emails" element={<AdminEmails />} />
            <Route path="automations" element={<AdminAutomations />} />
            <Route path="incidents" element={<AdminIncidents />} />
            <Route path="integrations" element={<AdminIntegrations />} />
            <Route path="legal" element={<AdminLegal />} />
            <Route path="billing" element={<AdminBilling />} />
            <Route path="stripe-connect" element={<AdminStripeConnect />} />
            <Route path="stripe" element={<AdminStripe />} />
          </Route>

          {/* CHEF */}
          <Route
            path="/chef"
            element={
              <ProtectedRoute role="chef">
                <ChefLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<ChefDashboard />} />
            <Route path="dashboard-settings" element={<ChefDashboardSettings />} />
            <Route path="salaries" element={<ChefSalaries />} />
            <Route path="planning" element={<ChefPlanning />} />
            <Route path="conges" element={<ChefConges />} />
            <Route path="paie" element={<ChefPaie />} />
            <Route path="documents" element={<ChefDocuments />} />
            <Route path="notifications" element={<ChefNotifications />} />
            <Route path="profil-entreprise" element={<ChefProfilEntreprise />} />
            <Route path="helper" element={<ChefHelper />} />
            <Route path="banques" element={<ChefBanques />} />
            <Route path="simulateur" element={<ChefSimulateur />} />
            <Route path="finance" element={<ChefFinance />} />
            <Route path="cse" element={<ChefCSE />} />
            <Route path="secteur/haccp" element={<ChefHACCP />} />
            <Route path="secteur/rondes" element={<ChefRondes />} />
            <Route path="secteur/chantiers" element={<ChefChantiers />} />
            <Route path="secteur/rdv" element={<ChefRDV />} />
            <Route path="secteur/vehicules" element={<ChefVehicules />} />
            <Route path="secteur/reservations" element={<ChefReservations />} />
            <Route path="secteur/biens" element={<ChefBiens />} />
            <Route path="secteur/pensionnaires" element={<ChefPensionnaires />} />
            <Route path="secteur/abonnes" element={<ChefAbonnes />} />
            <Route path="secteur/production" element={<ChefProduction />} />
            <Route path="education/eleves" element={<EducationEleves />} />
            <Route path="education/classes" element={<EducationClasses />} />
            <Route path="education/notes" element={<EducationNotes />} />
            <Route path="education/bulletins" element={<EducationBulletins />} />
            <Route path="education/presences" element={<EducationPresences />} />
            <Route path="education/presences-monthly" element={<EducationPresencesMonthly />} />
            <Route path="education/parents" element={<EducationParents />} />
            <Route path="minisite" element={<ChefMiniSite />} />
            <Route path="site" element={<SiteBuilderPage />} />
            <Route path="reservations" element={<ChefHebergement />} />
            <Route path="encaissement" element={<ChefEncaissement />} />
            <Route path="templates-rh" element={<ChefTemplatesRH />} />
            <Route path="sites" element={<ChefSites />} />
            <Route path="facturation" element={<ChefFacturation />} />
            <Route path="legal" element={<ChefLegal />} />
            <Route path="securite" element={<ChefSecurityCenter />} />
            <Route path="clients" element={<ChefClients />} />
            <Route path="avis" element={<ChefAvis />} />
            <Route path="devis-factures" element={<ChefDevisFactures />} />
            <Route path="rapprochement" element={<ChefRapprochement />} />
            <Route path="crm" element={<ChefCRM />} />
            <Route path="contrats" element={<ChefContrats />} />
            <Route path="pointage" element={<ChefPointage />} />
            <Route path="talk" element={<ChefTalk />} />
            <Route path="modules" element={<Navigate to="/chef/marketplace?kind=module" replace />} />
            <Route path="marketplace" element={<MarketplacePage portal="chef" />} />
            <Route path="billetterie" element={<BilletteriePage portal="chef" />} />
            <Route path="modules/:key" element={<ChefModulePage />} />
            <Route path="titres-restaurant" element={<ChefTitresRestaurant />} />
            <Route path="visites-medicales" element={<ChefVisitesMedicales />} />
            <Route path="paie-fiscal" element={<ChefPaieFiscal />} />
            <Route path="qualiparc/interventions" element={<ChefQualiParcInterventions />} />
            <Route path="qualiparc/audits" element={<ChefQualiParcAudits />} />
            <Route path="qualiparc/tickets" element={<ChefQualiParcTickets />} />
          </Route>

          {/* SYNDICAT */}
          <Route
            path="/syndicat"
            element={
              <ProtectedRoute role="syndicat">
                <SyndicatLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<SyndicatDashboard />} />
            <Route path="billetterie" element={<BilletteriePage portal="syndicat" />} />
            <Route path="adherents" element={<SyndicatAdherents />} />
            <Route path="plaintes" element={<SyndicatPlaintes />} />
            <Route path="actualites" element={<SyndicatActualites />} />
            <Route path="site" element={<SiteBuilderPage />} />
          </Route>

          {/* ASSOCIATION / ONG */}
          <Route
            path="/association"
            element={
              <ProtectedRoute role="association">
                <AssociationLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AssociationDashboard />} />
            <Route path="billetterie" element={<BilletteriePage portal="association" />} />
            <Route path="adherents" element={<AssociationAdherents />} />
            <Route path="plaintes" element={<AssociationPlaintes />} />
            <Route path="actualites" element={<AssociationActualites />} />
            <Route path="site" element={<SiteBuilderPage />} />
          </Route>

          {/* BUSINESS PARTNER (PAG JOB Phase B) */}
          <Route
            path="/bp"
            element={
              <ProtectedRoute role="bp">
                <BpLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<BpDashboard />} />
            <Route path="billetterie" element={<BpBilletterie />} />
            <Route path="leads" element={<BpLeads />} />
            <Route path="gains" element={<BpGains />} />
            <Route path="minisite" element={<BpMinisite />} />
            <Route path="site" element={<SiteBuilderPage />} />
            <Route path="contrat" element={<BpContrat />} />
            <Route path="catalogue" element={<BpCatalog />} />
            <Route path="reglement" element={<BpReglement />} />
            <Route path="profil" element={<BpProfil />} />
          </Route>

          {/* SALARIE */}
          <Route
            path="/salarie"
            element={
              <ProtectedRoute role="salarie">
                <SalarieLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<SalarieDashboard />} />
            <Route path="dashboard-settings" element={<SalarieDashboardSettings />} />
            <Route path="planning" element={<SalariePlanning />} />
            <Route path="conges" element={<SalarieConges />} />
            <Route path="remuneration" element={<SalarieRemuneration />} />
            <Route path="titres-restaurant" element={<SalarieTitresRestaurant />} />
            <Route path="paie" element={<SalariePaie />} />
            <Route path="documents" element={<SalarieDocuments />} />
            <Route path="contrat" element={<SalarieContrat />} />
            <Route path="pointage" element={<SalariePointage />} />
            <Route path="talk" element={<SalarieTalk />} />
            <Route path="modules/:key" element={<SalarieModulePage />} />
            <Route path="marketplace" element={<MarketplacePage portal="salarie" />} />
            <Route path="billetterie" element={<BilletteriePage portal="salarie" />} />
            <Route path="visites-medicales" element={<SalarieVisitesMedicales />} />
            <Route path="messages" element={<SalarieMessages />} />
            <Route path="helper" element={<SalarieHelper />} />
            <Route path="syndicat" element={<SalarieSyndicat />} />
            <Route path="ma-carte" element={<SalarieCardID />} />
            <Route path="qualiparc/interventions" element={<SalarieInterventions />} />
            <Route path="qualiparc/tickets" element={<SalarieTickets />} />
            <Route path="notifications-reglages" element={<SalarieNotifications />} />
            <Route path="legal" element={<SalarieLegal />} />
            <Route path="etablissement" element={<SalarieEtablissement />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </HostSiteGate>
      </BrowserRouter>
    </div>
  );
}

export default App;
